import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchDetectors } from "../../actions";
import { Content } from "../layout";
import { pageLimit as limit } from "../../config/keys";
// import Pagination from "../common/Pagination";
import { fabStyle } from "../common/style";

const DetectorList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector((state) => state.detector.detectors);
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user) {
      dispatch(fetchDetectors({ page, limit }));
    }
  }, [dispatch, page, user]);

  const navigateToDetectorDetail = (id) => {
    navigate(`/detectors/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderDetectors = () =>
    rows.map((detector) => (
      <TableRow
        key={detector.chipID}
        onClick={() => navigateToDetectorDetail(detector.id)}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>{detector.chipID}</TableCell>
        <TableCell>{detector.name}</TableCell>
        <TableCell>{detector.Repeater.devEUI}</TableCell>
        <TableCell>{detector.Repeater.name}</TableCell>
        <TableCell>{new Date(detector.createdAt).toLocaleString()}</TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            감지기
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="worker-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>칩 ID</TableCell>
                  <TableCell>감지기명</TableCell>
                  <TableCell>리피터 EUI</TableCell>
                  <TableCell>리피터명</TableCell>
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderDetectors()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/detectors/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default DetectorList;
